import { Box } from '@mantine/core';

import { RAFBanner } from '~/domains/user/domains/refer-a-friend/components/RAFBanner';
import { HomePopularChannels } from '~/domains/channel/components/HomePopularChannels/HomePopularChannels';
import PromoCarousel from '~/domains/promotions/components/PromoCarousel/PromoCarousel';
import { HomePredictionMarkets } from '~/domains/market/components/HomePredictionMarkets/HomePredictionMarkets';

import { PromoCarouselLocation } from '../promotions/types/enums';

import { CondensedCarouselsSlot } from './domains/condensed-carousels/components/CondensedCarouselsSlot/CondensedCarouselsSlot';
import { useHome } from './hooks/useHome';
import useHomeStyles from './Home.styles';
import HomeHeader from './Header';
import HomeFooter from './Footer';
import PlayWithPeopleYouFollow from './components/PlayWithPeopleYouFollow';
import HomeQuickpicks from './components/HomeQuickpicks';
import HomeWidgets from './components/HomeWidgets';
import HomeGroupInviteWidget from './components/HomeGroupInviteWidget';
import HomeLeagueLobbies from './components/HomeLeagueLobbies';

function Home() {
  const { classes, theme } = useHomeStyles();

  const {
    isQPpromoEnabled,
    isNotificationWidgetsEnabled,
    isPredictionMarketsWidgetEnabled,
    isSignedIn,
    homeOrder,
  } = useHome();

  return (
    <Box maw={theme.other.layout.maxWidth} m="0 auto">
      <Box component="section" className={classes.container}>
        <HomeHeader order={homeOrder.homeCarousel} />

        {isSignedIn && isNotificationWidgetsEnabled && (
          <HomeWidgets order={homeOrder.homeWidgets} />
        )}

        {isSignedIn && !isNotificationWidgetsEnabled && (
          <Box style={{ order: homeOrder.homeWidgets }}>
            <HomeGroupInviteWidget />
          </Box>
        )}

        {isQPpromoEnabled && <HomeQuickpicks order={homeOrder.quickpicks} />}

        {isPredictionMarketsWidgetEnabled && (
          <HomePredictionMarkets order={homeOrder.predictionMarkets} />
        )}

        <HomeLeagueLobbies order={homeOrder.leaguePills} />

        <PromoCarousel
          location={PromoCarouselLocation.HOME}
          order={homeOrder.promotions}
          isHeaderVisible
        />

        <CondensedCarouselsSlot slug="featured" order={homeOrder.featuredContests} />

        {isSignedIn ? (
          <>
            <HomePopularChannels order={homeOrder.popularChannels} />
            <PlayWithPeopleYouFollow order={homeOrder.followers} />
            <RAFBanner order={homeOrder.rafBanner} />
          </>
        ) : (
          <HomePopularChannels order={homeOrder.popularChannels} />
        )}

        <CondensedCarouselsSlot slug="homepage" order={homeOrder.contests} />

        <HomeFooter />
      </Box>
    </Box>
  );
}

export default Home;
